import * as React from 'react'
// types
import { ILog } from 'types/graphql'

// types
export declare namespace NActivityBL {
  export interface IContext {
    activity: ILog
    shouldShowSubCommentForm: boolean
    shouldShowCommentEditForm: boolean
    handleEditComment: () => void
    handleCloseEditCommentForm: () => void
    handleAddSubComment: () => void
    handleCloseSubCommentForm: () => void
  }

  interface IIncomingProps {
    activity: ILog
    children?: React.ReactNode
  }
}

export const ActivityBLContext = React.createContext<NActivityBL.IContext>({} as any)

const ActivityBL: React.FunctionComponent<NActivityBL.IIncomingProps> = ({ children, activity }) => {
  // state
  const [shouldShowSubCommentForm, setShouldShowSubCommentForm] = React.useState<boolean>(false)
  const [shouldShowCommentEditForm, setShouldShowCommentEditForm] = React.useState<boolean>(false)

  // methods
  const handleEditComment = () => setShouldShowCommentEditForm(true)
  const handleCloseEditCommentForm = () => setShouldShowCommentEditForm(false)

  const handleAddSubComment = () => setShouldShowSubCommentForm(true)
  const handleCloseSubCommentForm = () => setShouldShowSubCommentForm(false)

  const value = {
    activity,
    shouldShowSubCommentForm,
    shouldShowCommentEditForm,
    handleEditComment,
    handleCloseEditCommentForm,
    handleAddSubComment,
    handleCloseSubCommentForm
  }

  return <ActivityBLContext.Provider value={value}>{children}</ActivityBLContext.Provider>
}

export default ActivityBL
